import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export function ErrorFallback({
  error,
  reset,
}: {
  error: unknown;
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const message =
    error instanceof Error ? error.message : 'Something went wrong';
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <p className="text-destructive">{message}</p>
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground"
        onClick={reset}
      >
        Retry
      </button>
    </div>
  );
}
